export default __webpack_public_path__ + "static/box-8164040082053dadd0f511f6941f8da9.png";